import { CellSize } from 'bold-ui'

import { AgendarConsultaCellSizes } from './model-agendarConsultaAtendimento'

export function getRegistroTardioCellSizes(
  hasPainelLateral: boolean,
  showHorarioFinal: boolean
): AgendarConsultaCellSizes {
  return {
    lotacao: {
      md: 4,
      lg: 4,
    },
    emptyCell: {
      md: 8,
      lg: 8,
    },
    data: {
      md: 3,
      lg: showHorarioFinal ? 2 : getColumnLgSizeWithoutHorarioFinal(hasPainelLateral),
    },
    horarios: {
      md: showHorarioFinal ? 6 : 3,
      lg: showHorarioFinal
        ? getHorariosLgSizeWithHorarioFinal(hasPainelLateral)
        : getColumnLgSizeWithoutHorarioFinal(hasPainelLateral),
    },
  }
}

export function getAtendimentoCellSizes(
  hasPainelLateral: boolean,
  showHorarioFinal: boolean
): AgendarConsultaCellSizes {
  return {
    lotacao: {
      md: 6,
      lg: showHorarioFinal
        ? getLotacaoLgSizeWithHorarioFinal(hasPainelLateral)
        : getLotacaoLgSizeWithoutHorarioFinal(hasPainelLateral),
    },
    emptyCell: {
      md: 6,
      lg: showHorarioFinal
        ? getEmptyCellLgSizeWithHorarioFinal(hasPainelLateral)
        : getEmptyCellLgSizeWithoutHorarioFinal(hasPainelLateral),
    },
    data: {
      md: 3,
      lg: getColumnLgSizeWithoutHorarioFinal(hasPainelLateral),
    },
    horarios: {
      md: showHorarioFinal ? 6 : 3,
      lg: showHorarioFinal
        ? getHorariosLgSizeWithHorarioFinal(hasPainelLateral)
        : getColumnLgSizeWithoutHorarioFinal(hasPainelLateral),
    },
  }
}

function getLotacaoLgSizeWithHorarioFinal(hasPainelLateral: boolean): CellSize {
  return hasPainelLateral ? 7 : 5
}

function getLotacaoLgSizeWithoutHorarioFinal(hasPainelLateral: boolean): CellSize {
  return hasPainelLateral ? 6 : 5
}

function getEmptyCellLgSizeWithHorarioFinal(hasPainelLateral: boolean): CellSize {
  return hasPainelLateral ? 5 : 7
}

function getEmptyCellLgSizeWithoutHorarioFinal(hasPainelLateral: boolean): CellSize {
  return hasPainelLateral ? 6 : 7
}

function getHorariosLgSizeWithHorarioFinal(hasPainelLateral: boolean): CellSize {
  return hasPainelLateral ? 4 : 3
}

function getColumnLgSizeWithoutHorarioFinal(hasPainelLateral: boolean): CellSize {
  return hasPainelLateral ? 3 : 2
}
